import { unreadCount as unreadEducationCount } from '../../redux/modules/education/education-middleware';
import { loadNewTestResultsCount } from '../../redux/modules/test-results/test-results-middleware';
import { loadNewMedicalNotesCount } from '../../redux/modules/medical-notes/medical-notes-middleware';
import { loadNewQuestionnairesCount } from '../../redux/modules/questionnaires/questionnaires-middleware';
import { unseenCountTreatmentSummaryItems } from '../../redux/modules/treatment-summary/treatment-summary-middleware';
import { getUnreadCount } from '../../redux/modules/secure-message/secure-message-middleware';

export const mapCapabilities = (config, stateCounter, patientId, dispatch) => (
  config.map((capability) => {
    const mapped = {};
    mapped.id = capability.moduleName.toLowerCase();
    mapped.isTabItem = true;
    switch (mapped.id) {
      case 'dashboard': {
        mapped.route = '/dashboard';
        mapped.hamburgerMenuSortOrder = 0;
        mapped.hasHealthSummary = capability.details ?
          !!capability.details.find((x) => x.fieldName === 'HealthSummary') : false;
        mapped.tabSortOrder = 0;
        mapped.iconClassNames = 'dashboard fa fa-dashboard';
        break;
      }
      case 'appointments': {
        mapped.route = '/appointments';
        mapped.hamburgerMenuSortOrder = 1;
        mapped.tabSortOrder = 1;
        mapped.iconClassNames = 'appointments fa fa-calendar';
        break;
      }
      case 'treatmentsummary': {
        mapped.route = '/treatment-summary';
        mapped.hamburgerMenuSortOrder = 2;
        mapped.tabSortOrder = 2;
        mapped.badgeProperties = {
          dispatchMethod: patientId ? () => dispatch(unseenCountTreatmentSummaryItems(patientId)) : undefined,
          stateCounter: stateCounter ? stateCounter[mapped.id] : undefined,
        };
        mapped.iconClassNames = 'treatments fa fa-plus-square';
        break;
      }
      case 'followups': {
        mapped.route = '/followup-plan';
        mapped.hamburgerMenuSortOrder = 3;
        mapped.tabSortOrder = 3;
        mapped.iconClassNames = 'follow-up-plan ion ion-navigate';
        break;
      }
      case 'education': {
        mapped.route = '/education-articles';
        mapped.hamburgerMenuSortOrder = 4;
        mapped.tabSortOrder = 4;
        mapped.badgeProperties = {
          dispatchMethod: patientId ? () => dispatch(unreadEducationCount(patientId)) : undefined,
          stateCounter: stateCounter ? stateCounter[mapped.id] : undefined,
        };
        mapped.iconClassNames = 'education fa fa-mortar-board';
        break;
      }
      case 'questionnaires': {
        mapped.route = '/questionnaires';
        mapped.hamburgerMenuSortOrder = 5;
        mapped.tabSortOrder = 5;
        mapped.badgeProperties = {
          dispatchMethod: patientId ? () => dispatch(loadNewQuestionnairesCount(patientId)) : undefined,
          stateCounter: stateCounter ? stateCounter[mapped.id] : undefined,
        };
        mapped.iconClassNames = 'questionnaires ion ion-android-clipboard';
        break;
      }
      case 'testresults': {
        mapped.route = '/test-results';
        mapped.hamburgerMenuSortOrder = 6;
        mapped.tabSortOrder = 6;
        mapped.badgeProperties = {
          dispatchMethod: patientId ? () => dispatch(loadNewTestResultsCount(patientId)) : undefined,
          stateCounter: stateCounter ? stateCounter[mapped.id] : undefined,
        };
        mapped.iconClassNames = 'test-results fa fa-flask';
        break;
      }
      case 'medicalnotes': {
        mapped.route = '/medical-notes';
        mapped.hamburgerMenuSortOrder = 7;
        mapped.tabSortOrder = 7;
        mapped.badgeProperties = {
          dispatchMethod: patientId ? () => dispatch(loadNewMedicalNotesCount(patientId)) : undefined,
          stateCounter: stateCounter ? stateCounter[mapped.id] : undefined,
        };
        mapped.iconClassNames = 'medical-notes fa fa-file-text-o';
        break;
      }
      case 'securemessages': {
        mapped.route = '/secure-messages';
        mapped.hamburgerMenuSortOrder = 8;
        mapped.tabSortOrder = 8;
        mapped.badgeProperties = {
          stateCounter: stateCounter ? stateCounter[mapped.id] : undefined,
          dispatchMethod: patientId ?
            () => dispatch(getUnreadCount(patientId))
            : undefined,
        };
        mapped.isTabItem = false;
        break;
      }
      default:
        mapped.isTabItem = false;
        mapped.hamburgerMenuSortOrder = null;
        break;
    }
    return mapped;
  })
);
